import { Http } from "./http";
import { HttpApi } from './httpapi'

export class BasicService {

  static http = new Http();
  static httpapi = new HttpApi()

  static spliceImg(imgStr = '') {
    const url = 'https://api.goodyiyao.cn/';
    return imgStr.match(/^http|https/) ? imgStr : (url + imgStr);
  }

  static thumbImg(imgStr = '') {
    const thumb = '.jpg' || '.png' || '.gif'
    return imgStr.replace(thumb,'_thumb' + thumb)
  }

  static eliminateImg(imgUrl = '') {
    const url = 'https://api.goodyiyao.cn/';
    return imgUrl.replace(url, '');
  }

    /**
   *
   * @param {File | Blob} upfile
   * @param {'goods' | 'article' | 'certificates'} path_type
   * @param {String} action
   */
  static upload(upfile, path_type = '', action = 'uploadimage') {
    return this.http.upload(
      `/file/upload?path_type=${path_type}&action=${action}`,
      { upfile });
  }

  static uploadForUrl(file, path_type) {
    return this.upload(file, path_type).then(data => {
      return data.url;
    })
  }

  static bigImg(imgStr = '') {
    const thumb = '_thumb'
    if(imgStr.indexOf(thumb)>0) {
      return imgStr.replace(thumb,'')
    }else{
      return imgStr
    }
  }
}
